const players = document.querySelectorAll('.player--videojs .player__player');
const initPlayer = async playerElements => {
  // eslint-disable-next-line import/no-extraneous-dependencies
  const { Player } = await import('@3pc/player-videojs');

  const playerInstances = [];
  const playerNodes = playerElements || players;

  playerNodes.forEach(player => {
    const playerInstance = new Player({
      player,
      config: {},
    });

    playerInstance.init();
    playerInstances.push(playerInstance);
  });

  return playerInstances;
};

/* eslint-disable no-unused-vars */
const playerInstances = initPlayer(players);
/* eslint-enable no-unused-vars */

export { initPlayer };
